import ReactApexChart from 'react-apexcharts';
import { WIDGET_RADIAL_CHART } from '../../../Data/Widgets/GeneralWidgets';
import { CommonRadialProgressPropsType } from '../../../Type/WidgetsType';

const RadialProgressChart = ({ data }:CommonRadialProgressPropsType) => {
  const updatedOption = {
    ...WIDGET_RADIAL_CHART,
    series: data.chart.series,
    options: {
      ...WIDGET_RADIAL_CHART,
      chart: {
        ...WIDGET_RADIAL_CHART.chart,
        dropShadow: {
          ...WIDGET_RADIAL_CHART.chart?.dropShadow,
          color: data.chart.color,
        },
      },
      colors: [data.chart.color],
    },
  };
  return <ReactApexChart type='radialBar' height={130} series={updatedOption.series} options={updatedOption.options} />;
};

export default RadialProgressChart;
